// extracted by mini-css-extract-plugin
export default {"input":"SelectInput_input__4vZhb","label":"SelectInput_label__WvLIs"};